const railsCsrfToken = () => {
  return document.getElementsByName('csrf-token')[0].content
}

export default railsCsrfToken